import { post, toUrl } from './http-methods'

export default {
  get(type, id) {
    return post(`/versions/file_tokens/${type}/${id}`).then(resp => {
      if(resp.status === 200) {
        return toUrl(`/versions/file_tokens/${resp.json.data.jwt}`);
      } else {
        return Promise.reject(resp);
      }
    });
  }
}
